import Avatar from 'components/avatar';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import services from 'services';
import action from 'state/actions';
import styled from 'styled-components/macro';
import { modalActionType } from 'utils/constants';
import intlHelper from 'utils/helpers/intl.helper';
import DropdownButton from '../Buttons/DropDownButton';
import selectors from 'state/selectors';
import { ListButton, ListTitleButton } from 'components/Buttons/DropDownButton/style';
import Icon from 'components/Input/Icon';

const Name = styled.p`
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  font-weight: 500;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  margin-bottom: 5px;
`;

const Container = styled.div`
  display: flex;
  height: 50px;
  min-width: 190px;
`;

export interface UserBoxProps {
  image?: string;
  userName: string;
  onAvatarClick: Function;
}
const UserBox = ({ image, userName = 'user', onAvatarClick }: UserBoxProps) => {
  const { push } = useHistory();
  const t = intlHelper.useTranslator();
  const dispatch = useDispatch();
  const loginType = useSelector(selectors.user.getLoginType);
  const listButtons = [
    {
      label: t('User Settings'),
      action: () => dispatch(action.modal.openModal(modalActionType.USER_SETTINGS)),
    },
    {
      label: t('Password'),
      action: () => dispatch(action.modal.openModal(modalActionType.USER_PASSWORD)),
      disabled: loginType === 'lucyOAuth',
    },
    {
      label: t('Logout'),
      action: async () => {
        await dispatch(action.documents.unlockDocumentAction());
        await services.logout();

        dispatch(action.user.setUserLogout());
        dispatch(action.chatbot.reset());

        localStorage.removeItem('jwt');
        localStorage.removeItem('chatbot_session_id');
        push('/login');
      },
    },
  ]
    .filter(({ disabled }) => disabled === undefined || disabled === false)
    .map(({ label, action }) => (
      <ListButton key={label} onClick={action}>
        {label}
      </ListButton>
    ));

  return (
    <Container>
      <Avatar userName={userName} onClick={() => onAvatarClick()} image={image} />
      <div style={{ marginTop: 5 }}>
        <Name>{userName}</Name>
        <DropdownButton
          tooltip="user profile"
          Button={
            <ListTitleButton>
              Profile &nbsp; <Icon size="sm" icon="angle-down" />
            </ListTitleButton>
          }
        >
          {listButtons}
        </DropdownButton>
      </div>
    </Container>
  );
};

export default UserBox;
